module.exports = __webpack_public_path__ + "assets/img/jt-banner.1f45f8e0.png";